const scrapingTemplateCommentFormInitialValues = ({ id, comment }) => ({
  id,
  comment,
})

export default scrapingTemplateCommentFormInitialValues
